import $ from "jquery";
import debug from "bows";

const log = debug("general");
const body = $('body');
const $btn = $('.btn');

const $personLink = $('.person__link');
const $featuredResources = $('main').find('.featured-resources');

const $wysiwyg_tables = $('.wysiwyg').find('table');
const $top_link = $('a[href="#top"]');

function buttonFix() {
	$btn.wrapInner('<span class="btn__wrap"></span>');
}

function isPullFooterCTA() {
	$featuredResources.each(function () {
		let $this = $(this);
		let isLast = $this.nextAll().length;
		let isHP = $this.closest('.hp-bg').length;
		log(isHP);
		if (isLast === 0 && isHP === 0) {
			$('.footer-cta').addClass('footer-cta--pull');
		}

	})
}

function fix_tables() {
	$wysiwyg_tables.each(function () {
		let $this = $(this);

		$this.wrap('<div class="wysiwyg__table"></div>');
		$this.removeAttr('width');
		$this.find('td, th').removeAttr('width');
	});
}

function to_top() {
	$top_link.on('click', function () {


		let $where = $('#top');
		let whereTo = $where.offset().top;

		$('html, body').animate({
			scrollTop: whereTo
		}, 500, 'swing');

		$where.attr('tabindex', -1).addClass('removetabindex').focus();

	});
}

export function init() {
	if ($btn.length) {
		buttonFix();
	}

	if ($personLink.length) {
		$('.person__link').hover(function () {
			$(this).closest('.person').addClass('person--hover');
		}, function () {
			$(this).closest('.person').removeClass('person--hover');
		}).on('focus', function () {
			$(this).closest('.person').addClass('person--hover');
		}).on('blur', function () {
			$(this).closest('.person').removeClass('person--hover');
		});
	}

	$('.removetabindex').on('blur', function () {
		$(this).removeClass('removetabindex');
	});

	if ($featuredResources.length) {
		isPullFooterCTA();
	}

	if ($wysiwyg_tables.length) {
		fix_tables();
	}

	if ($top_link.length) {
		to_top();
	}
}

export default {
	init
};
